import { DifferentiationProps } from '@zola/zola-ui/src/components/PreAuthV3/Differentiation';
import { BackgroundType } from '@zola/zola-ui/src/components/PreAuthV3/FeaturedImage';
import { COLORS3 as COLORS } from '@zola/zola-ui/src/styles/emotion';

import ChangeDesktop from '../../../../../public/static-preauth/images/WeddingAlbums/differentiation/change_desktop.png';
import CustomizeDesktop from '../../../../../public/static-preauth/images/WeddingAlbums/differentiation/customize_desktop.png';
import WizardDesktop from '../../../../../public/static-preauth/images/WeddingAlbums/differentiation/wizard_desktop.png';

import ChangeTablet from '../../../../../public/static-preauth/images/WeddingAlbums/differentiation/change_tablet.png';
import CustomizeTablet from '../../../../../public/static-preauth/images/WeddingAlbums/differentiation/customize_tablet.png';
import WizardTablet from '../../../../../public/static-preauth/images/WeddingAlbums/differentiation/wizard_tablet.png';

import ChangeMobile from '../../../../../public/static-preauth/images/WeddingAlbums/differentiation/change_mobile.png';
import CustomizeMobile from '../../../../../public/static-preauth/images/WeddingAlbums/differentiation/customize_mobile.png';
import WizardMobile from '../../../../../public/static-preauth/images/WeddingAlbums/differentiation/wizard_mobile.png';

export const differentiationContent: DifferentiationProps['content'] = [
  {
    id: 'customize',
    subtitle: 'Customize your album your way',
    description:
      'Linen or leather cover? Soft gloss or satin? Choose the cover, colors, and paper type.',
    image: {
      background: {
        type: BackgroundType.COLOR,
        parameters: {
          color: COLORS.FOREST_100,
        },
      },
      foregroundImage: {
        desktopSrc: CustomizeDesktop,
        imgType: 'png',
        mobileSrc: CustomizeMobile,
        tabletSrc: CustomizeTablet,
      },
    },
  },
  {
    id: 'wizard',
    subtitle: 'Want a head start? Album Wizard designs it for you',
    description:
      'Our tool will pick the photos and arrange them for you — ready for you to edit and play around.',
    image: {
      background: {
        type: BackgroundType.COLOR,
        parameters: {
          color: COLORS.BAY_100,
        },
      },
      foregroundImage: {
        desktopSrc: WizardDesktop,
        imgType: 'png',
        mobileSrc: WizardMobile,
        tabletSrc: WizardTablet,
      },
    },
  },
  {
    id: 'change',
    subtitle: 'Start now, make changes later',
    description:
      'Whether you want to add more photos or switch up the layout, edit your album anytime and we’ll print it when you’re ready.',
    image: {
      background: {
        type: BackgroundType.COLOR,
        parameters: {
          color: COLORS.WINE_100,
        },
      },
      foregroundImage: {
        desktopSrc: ChangeDesktop,
        imgType: 'png',
        mobileSrc: ChangeMobile,
        tabletSrc: ChangeTablet,
      },
    },
  },
];
